import { motion } from "framer-motion";
import { Moon, Sun } from "lucide-react";
import { useTheme } from "../context/ThemeContext";


export default function ThemeToggle({ variant = "switch", className = "" }) {
  const { isDark, toggleTheme } = useTheme();

  if (variant === "icon") {
    return (
      <button
        type="button"
        onClick={toggleTheme}
        role="switch"
        aria-checked={isDark}
        aria-label={isDark ? "Switch to light mode" : "Switch to dark mode"}
        className={[
          "inline-flex h-11 w-11 items-center justify-center rounded-full border",
          "border-neutral-200 bg-white text-neutral-800 shadow-lg transition duration-200",
          "hover:-translate-y-0.5 hover:bg-neutral-100 hover:shadow-xl",
          "focus:outline-none focus-visible:ring-2 focus-visible:ring-neutral-500 focus-visible:ring-offset-2",
          "dark:border-neutral-700 dark:bg-neutral-800 dark:text-neutral-100 dark:hover:bg-neutral-700 dark:focus-visible:ring-offset-neutral-950",
          className,
        ].join(" ")}
      >
        {isDark ? <Moon aria-hidden="true" size={20} /> : <Sun aria-hidden="true" size={20} />}
      </button>
    );
  }

  return (
    <button
      type="button"
      onClick={toggleTheme}
      role="switch"
      aria-checked={isDark}
      aria-label="Toggle theme"
      className={[
        "relative inline-flex h-9 w-16 items-center rounded-full border shadow-sm",
        "transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-neutral-400/70 dark:focus-visible:ring-neutral-500/70",
        isDark ? "border-neutral-600 bg-neutral-800" : "border-neutral-300 bg-neutral-100",
      ].join(" ")}
    >
      <motion.span
        initial={false}
        animate={{ x: isDark ? 28 : 0 }}
        transition={{ type: "spring", stiffness: 700, damping: 35 }}
        className="absolute left-1 top-1 z-10 inline-flex h-7 w-7 items-center justify-center rounded-full bg-white shadow ring-1 ring-black/5 text-[11px] select-none dark:bg-neutral-100 dark:ring-black/10"
      >
        <span className={isDark ? "text-neutral-700" : "text-neutral-400"}>
          {isDark ? "🌙" : "☀️"}
        </span>
      </motion.span>

      <span className="sr-only">{isDark ? "Dark mode" : "Light mode"}</span>
    </button>
  );
}
